/**
 * Sorts an array of objects by a given property in ascending order.
 * @param {string} property - The property to sort by.
 */
const azSortByProperty = (property) => (a, b) => {
  if (!a || (!a[property] && b[property])) {
    return 1;
  }
  if (!b || (a[property] && !b[property])) {
    return -1;
  }

  const nameA = a[property]?.toUpperCase() ?? '';
  const nameB = b[property]?.toUpperCase() ?? '';

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

export default azSortByProperty;
